import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared-components/shared.module';

import { IncoActualreportingComponent } from './inco-actualreporting.component';

@NgModule({
  declarations: [
    IncoActualreportingComponent
  ],
  imports: [CommonModule, SharedModule],
  exports: [SharedModule, IncoActualreportingComponent]
})
export class IncoActualReportingModule {}
